var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('VisitType',{attrs:{"organizationId":_vm.organizationId,"professionalId":null,"total":_vm.totalVisitTypes,"type":'ORGANIZATION',"update":_vm.update,"visitTypes":_vm.visitTypes}}),_c('Box',{attrs:{"boxes":_vm.boxes,"organizationId":_vm.organizationId,"total":_vm.totalBoxes,"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }